import { ENDPOINTS } from 'utils/api/callApi'
import { ICarrierMatchesFilters } from 'apps/booking/types/carrierMatches'
import { generateApiActionTypes } from './generateActionTypes'

interface GetCarrierMatchesAction {
  payload: {
    callApi: boolean
    requestData: {
      endpoint: string
      group: string
      params: ICarrierMatchesFilters
      method: string
    }
    actionTypes: string[]
  }
}

export const CARRIER_MATCHES_ACTION_TYPES = generateApiActionTypes('CARRIER_MATCHES')

export const getCarrierMatches = (
  filters: ICarrierMatchesFilters,
  actionTypes = CARRIER_MATCHES_ACTION_TYPES
): GetCarrierMatchesAction => {
  const requestData = {
    endpoint: ENDPOINTS.laneMatchTriggers,
    group: 'shipment_carrier_list',
    params: filters,
    method: 'GET',
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(actionTypes),
    },
  }
}
